export default "__VITE_ASSET__C9KIRpJO__"